/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminListingReason = {
    ListingReasonNotCompetitive: 'not_competitive',
    ListingReasonBelowFloor: 'below_floor',
    ListingReasonStale: 'stale',
    ListingReasonMarketDropped: 'market_dropped'
} as const;
export type AdminListingReason = typeof AdminListingReason[keyof typeof AdminListingReason];


export function instanceOfAdminListingReason(value: any): boolean {
    for (const key in AdminListingReason) {
        if (Object.prototype.hasOwnProperty.call(AdminListingReason, key)) {
            if (AdminListingReason[key as keyof typeof AdminListingReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminListingReasonFromJSON(json: any): AdminListingReason {
    return AdminListingReasonFromJSONTyped(json, false);
}

export function AdminListingReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListingReason {
    return json as AdminListingReason;
}

export function AdminListingReasonToJSON(value?: AdminListingReason | null): any {
    return value as any;
}

export function AdminListingReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminListingReason {
    return value as AdminListingReason;
}

